module.exports = __webpack_public_path__ + "static/img/active3.396384ec.png";